<div class="col-md-12 mb-30" [hidden]="Data_Seleted_Cancel.id>0">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">Order</h5>
     <br/>
     <br/>
     <div class="row">
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">Letter Number</label>
        <input [(ngModel)]="Filter_Letter"  name="Filter_Letter" type="number" class="form-control"  placeholder="Type here to search...">
      </div>
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">Letter Customer</label>
        <input [(ngModel)]="Filter_Customer"  name="Filter_Customer" type="text" class="form-control"  placeholder="Type here to search...">
      </div>
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">Letter Type</label>
        <select class="custom-select" [(ngModel)]="Filter_Letter_Type">
          <option value="0">Active Items</option>
          <option value="1">All</option>
        </select>
      </div>
    </div>
     <div class="row">
      <div  class="form-group col-md-6" >
        <button  type="button" (click)="ReadData_Schedules()" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>

        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>ID</th>
              <th>Letter Number</th>
              <th>Customer Name</th>
              <th>Date</th>
              <th>Time</th>
              <th>Status</th>
              <th>Latest Action</th>
              <th>Association</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Schedules|filter:Filter_Customer:'customerName'">
             <td>{{DataList_Schedules.indexOf(item)+1}}</td>
              <td>{{item.code2}}</td>
              <td>{{item.code}}</td>
              <td>{{item.customerName}}</td>
              <td>{{item.persianDate}}</td>
              <td>{{item.clock}}</td>
              <td>
                <p *ngIf="item.coordination==-1" style="color:blue ;">In Progress</p>
                <p *ngIf="item.coordination==1" style="color:green ;">Coordinated</p>
                <p *ngIf="item.coordination==0" style="color:red ;">Not Coordinated</p>

                <p *ngIf="item.done==1" style="color:green ;">Completed</p>
                <p *ngIf="item.done==0" style="color:red ;">Not Cancelled</p>
              </td>
              <td>{{item.activity_date}}</td>
              <td>

                <p *ngFor="let itemDetail of item.relative_id">
                    {{itemDetail}}
                </p>
              </td>
              <td>
                <button ype="button" (click)="set_Record(item)" class="btn btn-info" >Assignment Order</button>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
  </div>
</div>


<div *ngIf="Data_Seleted_Cancel.id>0" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="tab nav-border" style="position: relative;">
      <div class="d-block d-md-flex justify-content-between">
        <div class="d-block w-100">
          <h5 class="card-title border-0 pb-0"> Order '{{Data_Seleted_Cancel.id}}' on
            <span style="display: inline-block;">{{Data_Seleted_Cancel.persianDate}}</span> from
            {{Data_Seleted_Cancel.clock}}
          </h5>
          <h5 class="card-title border-0 pb-0"> Letter Number '{{Data_Seleted_Cancel.code}}'</h5>

        </div>
        <div class="d-block d-md-flex nav-tabs-custom" style="margin-top: 50px;">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active show" id="months-tab" data-toggle="tab" href="#order" role="tab"
                aria-controls="months" aria-selected="true">Events</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#flowchart" role="tab"
                aria-controls="months" aria-selected="true">Instruments</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#form" role="tab" aria-controls="months"
                aria-selected="true">Assignment Order Form</a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#karshnas" role="tab" aria-controls="months"
                aria-selected="true">Calibration Representative </a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#link" role="tab" aria-controls="months"
                aria-selected="true"> Order Association </a>
            </li>
            <li class="nav-item">
              <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#filePeyvaset" role="tab" aria-controls="months"
                aria-selected="true"> Attachment </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="tab-content" id="myTabContent" style="margin-top: 50px;">
        <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div class="form-group col-md-12">
              <app-LetterRequestCustomerMissionActivity
                [inner_Letter_id]="Data_Seleted_Cancel.id"
                [inner_Customer_id]="Data_Seleted_Cancel.customerId">

              </app-LetterRequestCustomerMissionActivity>
            </div>

            <div class="form-group col-md-12">
              <br />
              <hr />
              <br />
            </div>

            <div class="form-group col-md-12">
              <app-LetterRequestCustomerMissionActivityList
                [inner_Letter_id]="Data_Seleted_Cancel.id"
                [inner_Customer_id]="Data_Seleted_Cancel.customerId">

              </app-LetterRequestCustomerMissionActivityList>
            </div>

          </div>

        </div>

        <div class="tab-pane fade show" id="flowchart" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div class="form-group col-md-12">
              <app-LetterRequestCustomerMissionActivityDevice
                [inner_Letter_id]="Data_Seleted_Cancel.id">

              </app-LetterRequestCustomerMissionActivityDevice>
            </div>

          </div>
        </div>

        <div class="tab-pane fade show" id="form" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div class="form-group col-md-12">
              <app-LetterRequestCustomerMissionActivityForm
                [inner_Letter_id]="Data_Seleted_Cancel.id"
                [inner_Customer_id]="Data_Seleted_Cancel.customerId">

              </app-LetterRequestCustomerMissionActivityForm>
            </div>

          </div>
        </div>

        <div class="tab-pane fade show" id="karshnas" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div class="form-group col-md-12">
              <app-CutomerKarshnas
                [inner_Customer]="Data_Seleted_Cancel.customerId">

              </app-CutomerKarshnas>
            </div>

          </div>
        </div>

        <div class="tab-pane fade show" id="link" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div class="form-group col-md-12">
              <app-LetterRequestCustomerMissionActivityRelative
                [inner_Schedule_id]="Data_Seleted_Cancel.id">

              </app-LetterRequestCustomerMissionActivityRelative>
            </div>

          </div>
        </div>

        <div class="tab-pane fade show" id="filePeyvaset" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">

            <div class="form-group col-md-12">
              <app-LetterRequestCustomerMissionFile
                [inner_Schedule_id]="Data_Seleted_Cancel.id">

              </app-LetterRequestCustomerMissionFile>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-right: 5px;"> Back
    </button>

    <button (click)="SwichActivityDevice(Data_Seleted_Cancel)" *ngIf="Data_Seleted_Cancel.dscVisible" type="button" class="btn btn-success" style="margin-right: 5px;">
      <i class="fa fa-eye"></i> Show Remarks in PDF
    </button>
    <button (click)="SwichActivityDevice(Data_Seleted_Cancel)" *ngIf="!Data_Seleted_Cancel.dscVisible" type="button" class="btn btn-danger" style="margin-right: 5px;">
      <i class="fa fa-eye-slash"></i>  Hide Remarks in PDF
    </button>

    <button (click)="SwichActivityVisible(Data_Seleted_Cancel)" *ngIf="Data_Seleted_Cancel.activityVisible" type="button" class="btn btn-success" style="margin-right: 5px;">
      <i class="fa fa-eye"></i> Show Events in PDF
    </button>
    <button (click)="SwichActivityVisible(Data_Seleted_Cancel)" *ngIf="!Data_Seleted_Cancel.activityVisible" type="button" class="btn btn-danger" style="margin-right: 5px;">
      <i class="fa fa-eye-slash"></i>  Hide Events in PDF
    </button>

    <a target="_blank" href="{{BaseUrl3}}{{Data_Seleted_Cancel.id}}"
      style="margin-right: 5px;" class="btn btn-info"><i class="fa fa-file-pdf-o"></i> PDF</a>
  </div>
</div>
